module.exports = __webpack_public_path__ + "img/8f3b9.9a74d29c.svg";